import { api } from '../core';
import { TOOLKIT_TAG } from '../constants';

export interface EditUserToolkitToolRequest {
  toolId: string;
  globalAdminAsUser?: string;
  toolName?: string;
  toolDescription?: string;
  prompt?: string;
}

const editUserToolkitToolApi = api.injectEndpoints({
  endpoints: (builder) => ({
    editUserToolkitTool: builder.mutation<void, EditUserToolkitToolRequest>({
      query: (body) => ({
        url: `toolkit/edit-user-tool`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [TOOLKIT_TAG],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useEditUserToolkitToolMutation } = editUserToolkitToolApi;
